import { CircleInformationFill } from '@tapsioss/react-icons';
import { createElement } from 'react';
import type { ComponentType, CSSProperties } from 'react';
import { toast } from 'sonner';
import type { ExternalToast } from 'sonner';
import s from './styles.module.scss';

type ToastInverseIcon = ComponentType<{ size?: number; style?: CSSProperties }>;

const DEFAULT_INVERSE_ICON_SIZE = 24;

export const toastSuccess = (msg: string, options?: ExternalToast) => toast.success(msg, options);

export const toastWarning = (msg: string, options?: ExternalToast) => toast.warning(msg, options);

export const toastInfo = (msg: string, options?: ExternalToast) => toast.info(msg, options);

export const toastError = (msg: string, options?: ExternalToast) => toast.error(msg, options);

export const toastInverse = (msg: string, Icon?: ToastInverseIcon, options?: ExternalToast) =>
  toast(msg, {
    ...options,
    icon: createElement(Icon || CircleInformationFill, { size: DEFAULT_INVERSE_ICON_SIZE }),
    classNames: { ...options?.classNames, toast: s.inverse },
  });
